import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_QR_CODE: GlameraIconDefinition = {
  name: 'qr-code',
  viewBox: '0 0 24 24',
  svg: `
    <g class="glm-qr-code-group">
      <rect class="glm-qr-code-block glm-qr-code-block-tl" width="5" height="5" x="3" y="3" rx="1" ry="1"></rect>
      <rect class="glm-qr-code-block glm-qr-code-block-tr" width="5" height="5" x="16" y="3" rx="1" ry="1"></rect>
      <rect class="glm-qr-code-block glm-qr-code-block-bl" width="5" height="5" x="3" y="16" rx="1" ry="1"></rect>
      <path class="glm-qr-code-bit" d="M21 16h-3a2 2 0 0 0-2 2v3"></path>
      <path class="glm-qr-code-bit" d="M21 21v.01"></path>
      <path class="glm-qr-code-bit" d="M12 7v3a2 2 0 0 1-2 2H7"></path>
      <path class="glm-qr-code-bit" d="M3 12h.01"></path>
      <path class="glm-qr-code-bit" d="M12 3h.01"></path>
      <path class="glm-qr-code-bit" d="M12 16v.01"></path>
      <path class="glm-qr-code-bit" d="M16 12h1"></path>
      <path class="glm-qr-code-bit" d="M21 12v.01"></path>
      <path class="glm-qr-code-bit" d="M12 21v-1"></path>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-qr-code-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './qr-code.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class QrCodeIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_QR_CODE;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
